<svg
  version="1.1"
  id="Layer_1"
  shape-rendering="geometricPrecision"
  text-rendering="geometricPrecision"
  image-rendering="optimizeQuality"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 512 512"
  style="enable-background: new 0 0 512 512"
  xml:space="preserve"
>
  <g id="Layer_x0020_1">
    <circle class="st0" cx="256" cy="256" r="250" class="st0" [ngStyle]="getStyle(circleColor)" />
    <g id="_350655096">
      <g>
        <path
          id="_350655600"
          class="st1"
          [ngStyle]="getStyle(outlineColor)"
          d="M303.7,265.3c-0.9,0-1.8-0.3-2.5-1c-38.6-38.6-78.5-78.5-78.5-118.6
				c0-19.9,13.2-36.9,32-41.4c14.9-3.5,35,1.3,49,24.4c14.8-24.4,36.8-28.2,51.9-23.7c16.5,4.9,31.8,21.8,28.6,48.2
				c-0.2,1.9-2,3.3-3.9,3.1c-1.9-0.2-3.3-2-3.1-3.9c2.7-22.4-10-36.5-23.7-40.6c-13.6-4.1-33.9,0.3-46.7,25.8
				c-0.6,1.2-1.8,1.9-3.2,1.9c-1.3,0-2.6-0.8-3.2-1.9c-10.3-20.6-26.8-30.5-44.2-26.4c-15.6,3.7-26.6,17.9-26.6,34.5
				c0,36.4,37.1,74.4,73.9,111.2c8.4-8.4,17-17.1,25.1-25.7c1.3-1.4,3.6-1.5,5-0.2c1.4,1.3,1.5,3.6,0.2,5
				c-8.9,9.5-18.5,19.1-27.8,28.3C305.5,264.9,304.6,265.3,303.7,265.3L303.7,265.3z"
        />
        <path
          id="_350655528"
          class="st1"
          [ngStyle]="getStyle(outlineColor)"
          d="M330.4,155.5c-1.7,0-3.4,0.2-5.2,0.6c-10.6,2.5-18,12.1-18,23.4c0,25.1,25.6,51.6,51.3,77.2
				c25.6-25.7,51.3-52.1,51.3-77.2c0-11.3-7.4-20.9-18-23.4c-11.8-2.8-23,4-30.1,18.2c-0.6,1.2-1.8,1.9-3.1,1.9v0
				c-1.3,0-2.6-0.7-3.2-1.9C349.3,162.2,340.3,155.5,330.4,155.5L330.4,155.5z M358.5,265.3c-0.9,0-1.8-0.3-2.5-1
				c-27.4-27.5-55.8-55.8-55.8-84.7c0-14.6,9.6-27,23.4-30.3c10.6-2.5,24.7,0.7,34.9,16.3c10.1-15.6,24.3-18.8,34.9-16.3
				c13.8,3.3,23.4,15.7,23.4,30.3c0,28.9-28.4,57.2-55.8,84.7C360.3,264.9,359.4,265.3,358.5,265.3z"
        />
        <path
          id="_350656200"
          class="st1"
          [ngStyle]="getStyle(outlineColor)"
          d="M161.8,362.6c35.9,0,51,9.9,65.6,19.4c15.3,10,29.7,19.4,67.4,19.4c2.7,0,6.3,0.1,10.9,0.1
				c23.2,0.3,71.5,1,92.2-4.4c8.2-2.1,11.4-4.3,12.1-8.3c0.8-4.2-0.1-7.7-2.7-10.6c-14.1-16.1-70.6-12.9-94.7-11.6
				c-2.6,0.1-5,0.3-6.9,0.4c0.4,8.6-3.3,12.4-5.5,13.9c-6.3,4.1-15.6,1.1-23.2-7.6c-8.3-9.5-24.4-19.6-47.7-30
				c-1.8-0.8-2.6-2.9-1.8-4.7c0.8-1.8,2.9-2.6,4.7-1.8c24.6,11,41,21.4,50.1,31.8c5.7,6.4,11.5,8.1,14.1,6.4c1.6-1,3-4.2,2.1-10.3
				c-0.1-0.3-0.1-0.6-0.2-1c-0.7-3.9-2.3-9-5.4-15.4c-24.1-46.4-51.7-70.2-82.1-70.8h-57.9v85.2C156.1,362.6,159,362.6,161.8,362.6
				L161.8,362.6z M331.1,408.8c-9.5,0-18.3-0.1-25.4-0.2c-4.4-0.1-8.2-0.1-10.8-0.1c-39.8,0-55.8-10.4-71.3-20.5
				c-16-10.4-31.1-20.3-73.8-17.9c-1,0-1.9-0.3-2.6-1c-0.7-0.7-1.1-1.6-1.1-2.6l0-92.4c0-0.9,0.4-1.8,1-2.5c0.7-0.7,1.6-1,2.5-1
				l61.5,0c17.4,0.3,34.1,7.6,49.7,21.6c13.8,12.4,26.8,30.3,38.6,53.1c0,0,0,0.1,0.1,0.1c2.8,5.8,4.5,10.7,5.5,14.8
				c2-0.1,4.6-0.2,7.5-0.4c27.3-1.5,84-4.7,100.4,14c4.1,4.6,5.5,10.2,4.3,16.6c-1.8,9.8-11.9,12.4-17.3,13.8
				C384.2,408,355.4,408.8,331.1,408.8L331.1,408.8z"
        />
        <path
          id="_350656128"
          class="st1"
          [ngStyle]="getStyle(outlineColor)"
          d="M344,334c-0.7,0-1.3-0.2-1.9-0.6c-1.6-1.1-2.1-3.2-1-4.9c4.8-7.4,3.1-10.5,2.5-11.5
				c-6.9-12.3-59.4-10.9-76.7-10.4c0,0-0.1,0-0.1,0c-1.9,0-3.5-1.5-3.5-3.4c-0.1-1.9,1.5-3.6,3.4-3.6c52.6-1.4,76.6,2.6,83,14
				c2.9,5.1,2,11.4-2.7,18.7C346.3,333.4,345.2,334,344,334L344,334z"
        />
        <path
          id="_350655936"
          class="st1"
          [ngStyle]="getStyle(outlineColor)"
          d="M101.6,381.1H146V259.3h-44.4V381.1z M149.5,388.2H98.1c-1.9,0-3.5-1.6-3.5-3.5V255.8
				c0-1.9,1.6-3.5,3.5-3.5l51.4,0c1.9,0,3.5,1.6,3.5,3.5l0,128.8C153.1,386.6,151.5,388.2,149.5,388.2L149.5,388.2z"
        />
        <path
          id="_350655768"
          class="st1"
          [ngStyle]="getStyle(outlineColor)"
          d="M381.3,367.8c-0.4,0-0.8-0.1-1.2-0.2c-1.8-0.7-2.7-2.7-2-4.6c2.9-7.6,2.8-13.5-0.4-17.8
				c-10-13.8-47.9-11.9-73-10.6c-6.6,0.3-12.3,0.6-16.9,0.6c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c4.4,0,10.1-0.3,16.6-0.6
				c28.2-1.4,66.8-3.3,79.1,13.5c4.6,6.3,5,14.6,1.3,24.5C384.1,366.9,382.7,367.8,381.3,367.8L381.3,367.8z"
        />
      </g>
      <path
        id="_350656080"
        class="st2"
        [ngStyle]="getStyle(sleeveColor)"
        d="M146,366.5l0-92.4v-14.7h-44.4v121.8H146v-14.6C146,366.5,146,366.5,146,366.5L146,366.5z"
      />
      <g>
        <path
          id="_350655552"
          class="st3"
          [ngStyle]="getStyle(handColor)"
          d="M153.1,277.5v85.2c3-0.1,6-0.2,8.7-0.2c35.9,0,51,9.9,65.6,19.4
				c15.3,10,29.7,19.4,67.4,19.4c2.7,0,6.3,0.1,10.9,0.1c23.2,0.3,71.5,1,92.2-4.4c8.2-2.1,11.4-4.3,12.1-8.3
				c0.8-4.2-0.1-7.7-2.7-10.6c-4.8-5.4-14.5-8.7-26.1-10.5c0,0,0,0,0,0c-0.4,0-0.7-0.1-1.1-0.2c-22.5-3.4-51.8-1.7-67.5-0.9
				c-2.6,0.1-5,0.3-6.9,0.4c0.4,8.6-3.3,12.4-5.5,13.9c-6.3,4.1-15.6,1.1-23.2-7.6c-8.3-9.5-24.4-19.6-47.7-30
				c-1.8-0.8-2.6-2.9-1.8-4.7c0.8-1.8,2.9-2.6,4.7-1.8c24.6,11,41,21.4,50.1,31.8c5.7,6.4,11.5,8.1,14.1,6.4c1.6-1,3-4.2,2.1-10.3
				c-0.1-0.3-0.1-0.6-0.2-1c-0.7-3.9-2.3-9-5.4-15.4c-2.7-5.2-5.4-10-8.2-14.6c-0.1-0.2-0.2-0.3-0.3-0.5
				c-6.4-10.6-13-19.6-19.8-27.2c-0.4-0.3-0.7-0.6-1-1c-16.5-17.9-34.1-27.1-52.8-27.4L153.1,277.5z"
        />
        <path
          id="_350655432"
          class="st3"
          [ngStyle]="getStyle(handColor)"
          d="M293.8,335c1.9,3.2,3.7,6.6,5.5,10.1c0,0,0,0.1,0.1,0.1c2.8,5.8,4.5,10.7,5.5,14.8
				c2-0.1,4.6-0.2,7.5-0.4c16.5-0.9,43.9-2.4,66.6,0.7c1.9-6.4,1.5-11.4-1.3-15.2c-5.3-7.3-18.6-10.2-33.6-11.1c0,0,0,0,0,0
				c-0.1,0-0.2,0-0.4,0c-13.1-0.8-27.4,0-39,0.5C300.7,334.7,297,334.9,293.8,335L293.8,335z"
        />
        <path
          id="_350655000"
          class="st3"
          [ngStyle]="getStyle(handColor)"
          d="M289.7,328.1c4.1-0.1,9-0.3,14.6-0.6c11.7-0.6,25.2-1.3,37.9-0.6c3.5-6.2,2-8.8,1.5-9.7
				c-6.1-10.9-47.7-11.1-69.2-10.6C279.6,312.9,284.7,320.1,289.7,328.1L289.7,328.1z"
        />
      </g>
      <path
        id="_350655336"
        class="st2"
        [ngStyle]="getStyle(heartColor)"
        d="M229.8,145.6c0,36.4,37.1,74.4,73.9,111.2c7.7-7.7,15.5-15.5,22.9-23.4
			c-15.2-17.7-26.5-35.7-26.5-53.9c0-14.6,9.6-27,23.4-30.3c10.6-2.5,24.7,0.7,34.9,16.3c5.5-8.5,12.2-13.3,18.9-15.5
			c1.6-21.1-10.6-34.4-23.9-38.4c-13.6-4.1-33.9,0.3-46.7,25.8c-0.6,1.2-1.8,1.9-3.2,1.9c-1.3,0-2.6-0.8-3.2-1.9
			c-10.3-20.6-26.8-30.5-44.2-26.4C240.7,114.8,229.8,129,229.8,145.6L229.8,145.6z"
      />
      <path
        id="_350654760"
        class="st2"
        [ngStyle]="getStyle(heartColor)"
        d="M307.2,179.6c0,25.1,25.6,51.6,51.3,77.2c25.6-25.7,51.3-52.1,51.3-77.2
			c0-11.3-7.4-20.9-18-23.4c-3.3-0.8-6.6-0.8-9.7-0.1c-0.3,0.1-0.7,0.2-1,0.3c-7.6,2-14.5,8.3-19.3,18c-0.6,1.2-1.8,1.9-3.1,1.9
			c-1.3,0-2.6-0.7-3.2-1.9c-6-12.1-15.1-18.8-24.9-18.8c-1.7,0-3.4,0.2-5.2,0.6C314.7,158.7,307.2,168.3,307.2,179.6L307.2,179.6z"
      />
    </g>
  </g>
</svg>
